import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import TableCell from 'components/Table/TableCell'
import buildUrl from '../../../utils/apiHelpers'
import { markListingAsSoldRequest, unmarkListingAsSoldRequest, reserveListingRequest, unreserveListingRequest, relistListingRequest, unmarkListingAsStaleRequest, checkRelistedListingRequest, boostListingRequest, cancelListingRequest } from 'actions/listingActions'
import MoreOptionsDropdown from '../MoreOptionsDropdown'
import DeleteListingConfirmationDialog from '../DeleteListingConfirmationDialog'
import Icon from 'components/atoms/ListingsTable/Icon'
import DeleteIcon, { DeleteSvg } from 'components/atoms/ListingsTable/DeleteIcon'
import Loader from 'components/atoms/ListingsTable/Loader'
import Button from '@material-ui/core/Button'
import { onBfcacheRestore } from '../../../utils/bfcacheHelpers'
import {
  trackEditListing,
  trackRelistListing,
  trackBoostListing,
  trackMarkAsSold,
  trackUnmarkAsSold,
  trackHoldListing,
  trackUnholdListing,
  trackUnmarkAsStale,
  trackDeleteListing
} from '../../../analytics/events/seller'

class TableRow extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isUpdating: false,
      intervalVariable: null,
      displayErrorMessage: false,
      errorMessage: 'Oops something went wrong, please reload the page or contact us at sellersupport@vinterior.co if the error persists',
      deleteDialogOpen: false,
      deleteError: null
    }

    this.notUpdating = this.isNotUpdating.bind(this)
    this.handleOpenDeleteDialog = this.handleOpenDeleteDialog.bind(this)
    this.handleCloseDeleteDialog = this.handleCloseDeleteDialog.bind(this)
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this)
    this.stopListeningForBfcacheRestore = null
  }

  componentDidMount () {
    this.stopListeningForBfcacheRestore = onBfcacheRestore(() => {
      clearInterval(this.state.intervalVariable)
      this.setState({ isUpdating: false, intervalVariable: null })
    })
  }

  componentWillUnmount () {
    if (this.stopListeningForBfcacheRestore) this.stopListeningForBfcacheRestore()
    clearInterval(this.state.intervalVariable)
  }

  handleOpenDeleteDialog () { this.setState({ deleteDialogOpen: true, deleteError: null }) }

  handleCloseDeleteDialog () { this.setState({ deleteDialogOpen: false, deleteError: null }) }

  handleConfirmDelete () {
    trackDeleteListing('seller-dashboard-listings')
    this.props.dispatch(cancelListingRequest(this.props.listing.id, this.props.selectedFilter))
      .then((data) => {
        if (data && data.success) {
          // The reducer removes the row from state, unmounting this component.
          this.setState({ deleteDialogOpen: false, deleteError: null })
        } else {
          this.setState({ deleteError: (data && data.error) || this.state.errorMessage })
        }
      })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.listing !== this.props.listing && this.state.isUpdating) {
      this.setState({ isUpdating: false })
    }
    if (prevProps.listing !== this.props.listing && this.props.listing.relisted) {
      clearInterval(this.state.intervalVariable)
    }
  }

  isNotUpdating () { return !this.state.isUpdating }

  // actions start
  handleBoostListing (listingId) { this.props.dispatch(boostListingRequest(listingId, this.props.selectedFilter)) }

  handleMarkAsSold (listingId) { this.props.dispatch(markListingAsSoldRequest(listingId, this.props.selectedFilter)) }

  handleUnmarkAsSold (listingId) { this.props.dispatch(unmarkListingAsSoldRequest(listingId, this.props.selectedFilter)) }

  handleReserveListing (listingId) { this.props.dispatch(reserveListingRequest(listingId, this.props.selectedFilter)) }

  handleUnreserveListing (listingId) { this.props.dispatch(unreserveListingRequest(listingId, this.props.selectedFilter)) }

  handleRelistListing (listingId) { this.props.dispatch(relistListingRequest(listingId, this.props.selectedFilter)) }

  handleCheckRelistedListing (listingId) {
    const startTime = new Date().getTime()
    const oneMinInMs = 60000
    const intervalVariable = setInterval(() => {
      this.props.dispatch(checkRelistedListingRequest(listingId, this.props.selectedFilter))
      const timeSinceStartTime = new Date().getTime() - startTime

      if (timeSinceStartTime > oneMinInMs) {
        clearInterval(this.state.intervalVariable)
        this.setState({ isUpdating: false })

        if (!this.props.listing.relisted) {
          this.setState({ displayErrorMessage: true })
        }
      }
    }, 3000)
    this.setState({ intervalVariable: intervalVariable })
  }

  handleMarkAsAvailable (listingId) { this.props.dispatch(unmarkListingAsStaleRequest(listingId, this.props.selectedFilter)) }

  // actions end

  renderBoostListingButton (listing) {
    return (
      <Button
        onClick={() => {
          this.handleBoostListing(listing.id)
          this.setState({ isUpdating: true })
          trackBoostListing('seller-dashboard-listings', listing.id)
        }}
        classes={{ root: 'boost-listing' }}
      >
        <Icon
          content='Boost'
          iconName='boost_listing.svg'
        />
      </Button>
    )
  }

  renderMarkAsSoldButton (listing) {
    return (
      <Button
        onClick={() => {
          this.handleMarkAsSold(listing.id)
          this.setState({ isUpdating: true })
          trackMarkAsSold('seller-dashboard-listings')
        }}
        classes={{ root: 'mark-as-sold' }}
      >
        <Icon
          content='Mark as sold'
          iconName='shopping_cart_crossed.svg'
        />
      </Button>
    )
  }

  renderUnmarkAsSoldButton (listing) {
    return (
      <Button
        onClick={() => {
          this.handleUnmarkAsSold(listing.id)
          this.setState({ isUpdating: true })
          trackUnmarkAsSold('seller-dashboard-listings')
        }}
        classes={{ root: 'unmark-as-sold' }}
      >
        <Icon
          content='Unmark as sold'
          iconName='shopping_cart.svg'
        />
      </Button>
    )
  }

  renderEditListingButton (listing) {
    return (
      <Button
        onClick={() => {
          this.setState({ isUpdating: true })
          trackEditListing('seller-dashboard-listings')
        }}
        href={buildUrl('/listings/' + listing.id + '/edit')}
        classes={{ root: 'edit-listing' }}
      >
        <Icon
          content='Edit'
          iconName='pencil.svg'
        />
      </Button>
    )
  }

  renderReserveListingButton (listing) {
    return (
      <Button
        onClick={() => {
          this.handleReserveListing(listing.id)
          this.setState({ isUpdating: true })
          trackHoldListing('seller-dashboard-listings')
        }}
        classes={{ root: 'hold-listing' }}
      >
        <Icon
          content='Mark as unavailable'
          iconName='lock.svg'
        />
      </Button>
    )
  }

  renderDeleteButton (listing) {
    return (
      <Button
        onClick={this.handleOpenDeleteDialog}
        classes={{ root: 'delete-listing' }}
        aria-label='Delete listing'
      >
        <DeleteIcon content='Delete' />
      </Button>
    )
  }

  renderUnreserveListingButton (listing) {
    return (
      <Button
        onClick={() => {
          this.handleUnreserveListing(listing.id)
          this.setState({ isUpdating: true })
          trackUnholdListing('seller-dashboard-listings')
        }}
        classes={{ root: 'unhold-listing' }}
      >
        <Icon
          content='Mark as available'
          iconName='lock_open.svg'
        />
      </Button>
    )
  }

  renderAddPhotoButton (listing) {
    if (listing.p2p) return

    return (
      <Button
        onClick={() => { this.setState({ isUpdating: true }) }}
        href={buildUrl('/listings/' + listing.id + '/photos/upload')}
      >
        <Icon
          content='Add photos'
          iconName='add_photo.svg'
        />
      </Button>
    )
  }

  renderUpdatePriceButton (listing) {
    if (listing.p2p) return

    return (
      <Button
        onClick={() => { this.setState({ isUpdating: true }) }}
        href={buildUrl('/listings/' + listing.id + '/edit?#price-section')}
      >
        <Icon
          content='Update price'
          iconName='update_price.svg'
        />
      </Button>
    )
  }

  renderRelistButton (listing) {
    return (
      <Button
        onClick={() => {
          this.handleRelistListing(listing.id)
          this.setState({ isUpdating: true })
          this.handleCheckRelistedListing(listing.id)
          trackRelistListing('seller-dashboard-listings')
        }}
        classes={{ root: 'relist-listing' }}
      >
        <Icon
          content='Relist'
          iconName='shopping_cart.svg'
        />
      </Button>
    )
  }

  renderMarkAsAvailableButton (listing) {
    return (
      <Button
        onClick={() => {
          this.handleMarkAsAvailable(listing.id)
          this.setState({ isUpdating: true })
          trackUnmarkAsStale('seller-dashboard-listings')
        }}
        classes={{ root: 'unmark-as-stale' }}
      >
        <Icon
          content='Available'
          iconName='check_circle.svg'
        />
      </Button>
    )
  }

  renderCTAs (listing) {
    if (!this.isNotUpdating()) return null
    if (this.state.displayErrorMessage) return null

    const { status, relistedAtFormatted, isBeingRelisted, isBoosted, boostsLeft } = listing
    const shouldShowMarkAsSoldButton = ['Published', 'On hold', 'Auto marked as stale'].includes(status)
    const shouldShowMoreOptionsDropdown = ['Published', 'On hold', 'Auto marked as stale'].includes(status) || (status === 'Action required' && !listing.p2p)
    // P2P sellers get Delete inline in place of "Mark as unavailable" on Published
    // rows; everywhere else Delete lives in the More dropdown.
    const showInlineDelete = status === 'Published' && listing.p2p
    const showDeleteInDropdown = shouldShowMoreOptionsDropdown && !showInlineDelete
    const dropdownActions = showDeleteInDropdown
      ? [{ key: 'delete', label: 'Delete listing', icon: <DeleteSvg size={20} />, onClick: this.handleOpenDeleteDialog }]
      : []

    return (
      <td className='vsd-listing-ctas flex items-start justify-center gap-8'>
        {status === 'Published' && !isBoosted && boostsLeft && this.props.canBoostListings && listing.price >= 600 ? this.renderBoostListingButton(listing) : ''}
        {shouldShowMarkAsSoldButton ? this.renderMarkAsSoldButton(listing) : ''}
        {status === 'Published' && !listing.p2p ? this.renderReserveListingButton(listing) : ''}
        {showInlineDelete ? this.renderDeleteButton(listing) : ''}
        {status === 'On hold' ? this.renderUnreserveListingButton(listing) : ''}
        {status === 'Action required' ? this.renderUpdatePriceButton(listing) : ''}
        {status === 'Action required' ? this.renderAddPhotoButton(listing) : ''}
        {status === 'Draft' || status === 'Awaiting approval' ? this.renderEditListingButton(listing) : ''}
        {status === 'Auto marked as sold' ? this.renderUnmarkAsSoldButton(listing) : ''}
        {status === 'Auto marked as stale' ? this.renderMarkAsAvailableButton(listing) : ''}
        {status === 'Action required' && listing.p2p ? this.renderEditListingButton(listing) : ''}

        {shouldShowMoreOptionsDropdown
          ? <MoreOptionsDropdown
              listing={listing}
              actions={dropdownActions}
              isUpdating={() => this.setState({ isUpdating: true })}
            />
          : ''}

        {relistedAtFormatted ? `Relisted on ${relistedAtFormatted}`
          : isBeingRelisted ? 'This listing is being relisted. It can take a few minutes.'
            : status === 'Sold' && !listing.relisted ? this.renderRelistButton(listing) : ''}

        <DeleteListingConfirmationDialog
          open={this.state.deleteDialogOpen}
          onCancel={this.handleCloseDeleteDialog}
          onConfirm={this.handleConfirmDelete}
          errorMessage={this.state.deleteError}
        />
      </td>
    )
  }

  render () {
    const { listing, gridTemplateColumns } = this.props
    const { sellerReference, photo, title, sku, priceFormatted, createdAtFormatted, status, feedbackNotes, rejectionNotes, listingNotes, isBeingRelisted, deliverySize, isBoosted } = this.props.listing
    const notesToShow = status === 'Action required' || status === 'Disapproved'
    const className = notesToShow ? 'grid p-16 gap-x-16 grid-rows-[40px]' : 'grid p-16 gap-x-16 grid-rows-[minmax(80px,max-content)]'
    return (
      <tr className={'border-b border-midnight-black-20 hover:bg-[#FBFCFC] ' + className} style={{ gridTemplateColumns: gridTemplateColumns }}>
        <TableCell content={sellerReference} photo={photo} alt={title} />
        <TableCell content={title} />
        <TableCell content={sku} />
        <TableCell content={priceFormatted} />
        <TableCell content={createdAtFormatted} />
        <TableCell content={deliverySize} />

        {/* Doing this here to avoid the rabbit hole of having a "Sponsored" listing status in the current setup */}
        {status == "Published" && isBoosted 
          ? <TableCell content="Sponsored" type='status' />
          : <TableCell content={status} type='status' />}

        {!isBeingRelisted && this.state.isUpdating && !this.state.displayErrorMessage ? <td> <Loader /> </td> : this.renderCTAs(listing)}
        {this.state.displayErrorMessage && <td> {this.state.errorMessage} </td>}
        {status === 'Action required' &&
          <td className='col-[4/7] mt-20 py-[5px] px-8 bg-punch-lime-20 rounded min-h-[32px] [@media(max-width:992px)]:mt-10 [@media(max-width:992px)]:w-auto'>
            {!photo && !feedbackNotes && <div> Please add photos to this listing </div>}
            {!priceFormatted && !feedbackNotes && <div> Please add a price for this listing </div>}
            {feedbackNotes && <div> {feedbackNotes.notes} </div>}
            {listingNotes && <div> {listingNotes} </div>}
          </td>}
        {status === 'Disapproved' &&
          <td className='col-[4/7] mt-20 py-[5px] px-8 rounded min-h-[32px] [@media(max-width:992px)]:mt-10 [@media(max-width:992px)]:w-auto' style={{ backgroundColor: 'rgb(255, 207, 219, 0.3)' }}>
            {rejectionNotes && rejectionNotes.notes}
          </td>}
      </tr>
    )
  }
}

TableRow.propTypes = {
  listing: PropTypes.object,
  gridTemplateColumns: PropTypes.string,
  canBoostListings: PropTypes.bool
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

export default connect(mapDispatchToProps)(TableRow)
